<template>
  <div class="order-food-table-drag-btn">
    <el-button v-if="isSorting" type="primary" icon="el-icon-d-caret " :class="[handlerClass]" circle size="mini"></el-button>
    <div v-else>
      {{ index + 1 }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderFoodTableDragBtn',
  props: {
    isSorting: {
      type: Boolean,
      required: true
    },
    handlerClass: {
      type: String,
      default: 'drag-handle'
    },
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.order-food-table-drag-btn {
    ::v-deep .el-button {
      width: 32px;
      height: 32px;
      cursor: move;
    }
    ::v-deep .el-button i {
      padding: 0;
    }
}
</style>
